import { Directive, ElementRef, Input, OnChanges, OnInit, Renderer2 } from '@angular/core';
import { PDF_WIDTH_MM } from '@app/custom-shared/services/pdf/pdf-gen.service';

@Directive({
  selector: '[pdfGenenrator]',
})
export class PdfGeneratorDirective implements OnInit, OnChanges {

  @Input() pdfGenenrator: string;
  @Input() preview;
  
  constructor(private pdfRender: ElementRef, private renderer: Renderer2) { }

  ngOnInit(): void {
    this.renderer.setProperty(this.pdfRender.nativeElement, 'id', this.pdfGenenrator);
    this.renderer.setStyle(this.pdfRender.nativeElement, 'position', 'absolute'); 
    this.renderer.setStyle(this.pdfRender.nativeElement, 'top', 0); 
    this.showOrHide();
  } 

  ngOnChanges() {
    this.renderer.setStyle(this.pdfRender.nativeElement, 'width', PDF_WIDTH_MM);
    this.showOrHide();
  }

  showOrHide() {
    
    if (this.preview != undefined) {
      this.renderer.setStyle(this.pdfRender.nativeElement, 'visibility', 'visible');
      this.renderer.setStyle(this.pdfRender.nativeElement, 'z-index', 0);
    } else {
      this.renderer.setStyle(this.pdfRender.nativeElement, 'visibility', 'hidden');
      this.renderer.setStyle(this.pdfRender.nativeElement, 'z-index', -999);
    }
  }
}